//koristi se login template

import BaseParagraph from "../../../baseComponents/baseParagraph";
import BaseButton from "../../../baseComponents/baseButton";

import { useSelector, useDispatch } from "react-redux";
import LoginTemplate from "../../loginStack/LoginTemplate.js";
import { useRef, useState, useEffect } from "react";
import Mail from "../../../assets/mail.svg";
import Mobile from "../../../assets/mobile.svg";
import { asyncActions as loginAsyncActions } from "../../../store/slices/loginSlice";
import EmailVerificationFragment from "./fragments/EmailVerificationFragment.js";
import PhoneVerificationFragment from "./fragments/PhoneVerificationFragment.js";

const NotVerifiedView = ({
  PHONE = false,
  EMAIL = false,
  showHomePage = true,
  autoRelogin = true,
  isInModal = false,
  modalFullyOpened = false,
  setModalError = () => {}
}) => {
  ///////////////////////////////////////////////////////////////refs

  const itemFocusRef = useRef();
  const dispatch = useDispatch();

  ///////////////////////////////////////////////////////////////reudx state
  const loginState = useSelector((state) => state.loginState);
  const userState = useSelector((state) => state.userState);

  const [verificationAttempted, setVerificationAttempted] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  ///////////////////////////////////////////////////////////////styles
  const styles = {
    flexColumnContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    verificationHeading: {
      fontSize: "40px",
      textAlign: "center",
      marginBottom: "0.5em",
    },
    verificationMessage: {
      fontSize: "24px",
      marginBottom: "0.5em",
    },
    button: {
      paddingLeft: "1em",
      paddingRight: "1em",
      paddingTop: "0.5em",
      paddingBottom: "0.5em",
    },
  };

  ///////////////////////////////////////////////////////////////methods
  const refreshToRoot = () => {
    window.location.href = "/";
  };

  const checkCurrentVerificationStatus = () => {
    const innerPromise = dispatch(
      loginAsyncActions.checkCurrentVerificationStatus({})
    );

    return innerPromise;
  };

  const fullPhoneNumber = loginState.login.userInfo.fullPhoneNumber;

  ///////////////////////////////////////////////////////////////effects

  useEffect(() => {
    setModalError(errorMsg);
  }, [errorMsg]);

  ///////////////////////////////////////////////////////////////render
  return (
    <>
      <LoginTemplate
        showPickers={false}
        icon={EMAIL ? Mail : Mobile}
        stretchNoColumns={isInModal}
        heading={EMAIL ? "emailNotVerified" : "phoneNotVerified"}
        focusElement={itemFocusRef}
        autoRelogin={autoRelogin}
        isInModal={isInModal}
        modalFullyOpened={modalFullyOpened}
      >
        <div style={styles.flexColumnContainer}>
          {/* naslov */}

          {errorMsg === "" && (
            <>
              {/* body */}
              <BaseParagraph style={{}}>
                {EMAIL ? "emailNotVerifiedMessage" : "phoneNotVerifiedMessage"}
              </BaseParagraph>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                {/* broj telefona ili mail */}
                <BaseParagraph
                  translate={false}
                  style={styles.verificationMessage}
                >
                  <br />
                  {EMAIL ? loginState.login.userInfo.email : fullPhoneNumber}
                </BaseParagraph>
              </div>
            </>
          )}

          {PHONE && (
            <PhoneVerificationFragment
              setVerificationAttempted={setVerificationAttempted}
              setErrorMsg={setErrorMsg}
              checkCurrentVerificationStatus={checkCurrentVerificationStatus}
              itemFocusRef={itemFocusRef}
            
            />
          )}

          {EMAIL && (
            <EmailVerificationFragment
              setVerificationAttempted={setVerificationAttempted}
              setErrorMsg={setErrorMsg}
              checkCurrentVerificationStatus={checkCurrentVerificationStatus}
              itemFocusRef={itemFocusRef}
              
            />
          )}

          {showHomePage && (
            <BaseButton
              error={errorMsg}
              onClick={refreshToRoot}
              style={styles.button}
            >
              homePage
            </BaseButton>
          )}
          
        </div>
      </LoginTemplate>
    </>
  );
};





export default NotVerifiedView;
